import type { PaletteOptions } from '@mui/material';

const darkPalette: PaletteOptions = {
  mode: 'dark',
  primary: {
    light: '#5487AC',
    main: '#2577A0',
    dark: '#1E668A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#EF5455',
    contrastText: '#FFFFFF',
  },
  gradient: {
    light: '#389CC3',
    main: '#2577A0',
    dark: '#125680',
    contrastText: '#FFFFFF',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#D9D9D9',
    disabled: '#9E9E9E',
  },
  background: {
    default: '#1A1A1A',
    paper: '#2C2C2C',
  },
  success: {
    main: '#57BA56',
    contrastText: '#FFFFFF',
  },
  info: {
    main: '#19B5CD',
    contrastText: '#FFFFFF',
  },
  warning: {
    main: '#FFC107',
    contrastText: '#FFFFFF',
  },
  error: {
    main: '#DC3545',
    contrastText: '#FFFFFF',
  },
  purple: {
    main: '#721D6C',
    contrastText: '#FFFFFF',
  },
  teal: {
    main: '#00BFB2',
    contrastText: '#FFFFFF',
  },
  orange: {
    main: '#FD9C4D',
  },
  pink: {
    main: '#E87EA1',
  },
  common: {
    black: '#1A1A1A',
    white: '#FFFFFF',
  },
  divider: '#333333',
  grey: {
    '50': '#1A1A1A',
    '100': '#2C2C2C',
    '200': '#333333',
    '300': '#444444',
    '400': '#666666',
    '500': '#888888',
    '600': '#AAAAAA',
    '700': '#C8C8C8',
    '800': '#E0E0E0',
    '900': '#FFFFFF',
    A100: '#2A2A2A',
    A200: '#3C3C3C',
    A400: '#999999',
    A700: '#D9D9D9',
  },
  tonalOffset: {
    dark: 0.4,
    light: 0.2,
  },
};

export { darkPalette };
